import { typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const KeyValueElementRoot = styled.div<{
  $isDefaultVariant: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  height: 70px;
  justify-content: space-between;

  ${({ $isDefaultVariant }) =>
    $isDefaultVariant &&
    css`
      border-left: 2px solid var(--border-soft);
      padding-left: 12px;
      gap: 8px;
    `}
`;

export const Title = styled.div`
  ${typographyV2.titleSm};
  color: var(--text-soft);
`;

export const Details = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const Value = styled.span`
  ${typographyV2.bodyMd};
  font-family: var(--font-roboto-mono);
`;
export const Unit = styled.span`
  ${typographyV2.bodyXs};
`;
